<template>
    <g
        width="150px"
        height="160px"
    >
      <g transform="scale(0.50)">
        <text
            style="transform:translate(30px, 10px)"
            class="name st1"
            @click="displayValueBox"
            >저항{{ number }}({{ resist }}Ω)</text>
        <g class="resistor-whole" style="transform:translate(0px,-50px)">
            <g>
                <path
                    style="transform:translate(-5px,0px)"
                    class="st7"
                    d="M166.65,96.75h33.89c0,0,4.69-0.04,5.05,5.05c0,0-0.2,5.05-5.05,5.05l-33.89,0.04L166.65,96.75z"
                />
                <path
                    style="transform:translate(5px,0px)"
                    class="st7"
                    d="M50.58,96.75H16.69c0,0-4.69-0.04-5.05,5.05c0,0,0.2,5.05,5.05,5.05l33.89,0.04L50.58,96.75z"
                />
            </g>
            <g class="resistor-body">
                <path
                    class="st0"
                    d="M136.92,85.25H80.37c0,0-1.58-3.78-8.08-3.78h-17.4c0,0-4.27-0.08-4.27,4.52v31.07c0,0-0.7,5.59,4.27,4.85
                l17.4,0c0,0,5.58,0.25,8.08-3.78h56.55c0,0,2.1,3.78,8.22,3.78h17.26c0,0,4.27,0.08,4.27-3.78V85.25c0,0,0.16-3.78-4.27-3.78
                h-17.26C145.13,81.47,139.34,81.55,136.92,85.25z"
                />
                <rect
                    x="90.24"
                    y="85.28"
                    class="st1"
                    width="12.08"
                    height="32.88"
                    :id="'color2'"
                    :style="threeColors.color2"
                />
                <rect
                    x="114.67"
                    y="85.28"
                    class="st2"
                    width="12.08"
                    height="32.88"
                    :id="'color3'"
                    :style="threeColors.color3"
                />
                <rect
                    x="61.09"
                    y="81.6"
                    class="st3"
                    width="11.18"
                    height="40.44"
                    :id="'color1'"
                    :style="threeColors.color1"
                />
                <rect
                    x="152.68"
                    y="81.5"
                    class="st4"
                    width="5.63"
                    height="40.44"
                />
                <rect
                    x="152.68"
                    y="93.5"
                    class="st5"
                    width="5.63"
                    height="9.04"
                />
                <rect
                    x="152.68"
                    y="81.5"
                    class="st6"
                    width="5.63"
                    height="12"
                />
            </g>
            <g class="pin">
                <!--<circle class="snap" cx="20" cy="102.5" r="10" />-->
                <rect
                    :id="pincode + 'PS'"
                    @click="onClick(`${pincode}PS`)"
                    class="pin-cover terminal snap"
                    x="5"
                    y="90"
                    width="25"
                    height="25"
                />
            </g>
            <g class="pin">
                <!--<circle class="snap" cx="200" cy="102.5" r="10" />-->
                <rect
                    :id="pincode + 'MS'"
                    @click="onClick(`${pincode}MS`)"
                    class="pin-cover terminal snap"
                    x="190"
                    y="90"
                    width="25"
                    height="25"
                />
            </g>
            
        </g>
    </g>
    <!-- <elct-tooltip
      v-if="false"
      :pos="tooltipPos"
      :data="tooltip.data"
    >
      <text transform="matrix(1 0 0 1 70 -65)"> 부품 id: {{data.id}} </text>
      <text transform="matrix(1 0 0 1 70 -45)"> 전압: {{values.volt}} V </text>
      <text transform="matrix(1 0 0 1 70 -25)"> 전류: {{values.amper.toFixed(6)}} A </text>
      <text transform="matrix(1 0 0 1 70 -5)"> 저항: {{values.resist}} Ω </text>
    </elct-tooltip> -->
    
    <g transform="scale(0.50)">
        <g>
          <rect
                x="50"
                y="150"
                class="padbox"
                width="1"
                height="1"
            />
        </g>
      </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Resistor',
  data () {
    return {
      resist: 330,
      code: '',
      colors: [
        // EIA-RS-279
        'black',
        'brown',
        'red',
        'orange',
        'yellow',
        'green',
        'blue',
        'violet',
        'grey',
        'white'
      ]
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  computed: {
    values () {
      const data = store.state.sim.data
      if (data) return data.RE[Number(this.number)]
      return { volt: 0, amper: 0, resist: 0 }
    },
    threeColors () {
      return this.getColors(this.resist)
    }
  },
  methods: {
    onClick (pin) {
      // console.log('where is data?: ' + JSON.stringify(this.data))
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    displayValueBox () {
      window.event.stopPropagation()
      store.state.valuebox.values.toggle = false
      store.commit('setValueBox', { type: 'resist', toggle: true, id: this.data.id })
    },
    calColor (value) {
      value = String(value)
      let zidx = 0
      if (value.charAt(2) !== '0') zidx = value.length - 2
      else {
        zidx = value.length - value.indexOf('0')
        if (zidx === -1) zidx = 0
      }

      return {
        first: parseInt(value.charAt(0)),
        second: parseInt(value.charAt(1)),
        third: parseInt(zidx)
      }
    },
    getColors (value) {
      let obj
      if (value >= 1 && value <= 90000000) {
        obj = this.calColor(value)
      } else {
        obj = this.calColor(330)
      }
      const color1 = this.colors[obj.first]
      const color2 = this.colors[obj.second]
      const color3 = this.colors[obj.third]

      return {
        color1: { fill: color1 },
        color2: { fill: color2 },
        color3: { fill: color3 }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
    display: block;
    stroke: none;
    fill: transparent;
}
.pin:hover {
  cursor: pointer;
  .pin-cover {
      stroke-width: 5px;
      stroke: black;
      fill: #ff6f61;
  }
}
.selected {
  .st0,
  .st7 {
      stroke-width: 4px;
      stroke: #ff6f61;
  }
}
.resistor-wrapper {
    display: inline-block;
    position: absolute;
    top: 300px;
    left: 500px;
    z-index: 4;
}
.highlight {
  -webkit-filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
  filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
}
.st0 {
    fill: #ebcf8e;
}
.st1 {
    fill: #050000;
} //2번째 띠
.st2 {
    fill: #853d21;
} //3번째 띠
.st3 {
    fill: #b81c22;
} //1번째 띠
.st4 {
    fill: #665f2f;
}
.st5 {
    fill: #a99c4e;
}
.st6 {
    fill: #cac345;
}
.st7 {
    fill: #9fa0a0;
} //양쪽 철
.name {
    font-size: 30px;
}
.name:hover {
    cursor: pointer;
}
</style>
